angular.module('ui.order',
    [
        'ui.order.newOrderRouteContainer',

        'ui.order.orderDetailedRouteContainer',
        'ui.order.orderDetailed',

        'ui.order.stepDetailedRouteContainer',
        'ui.order.stepDetailed',

        'ui.order.orderItemsGridRouteContainer',
        'ui.order.orderItemsGrid',

        'ui.order.orderItemCard',

        'ui.order.orderItemsGridSharedSettings'
    ]);
